var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9.14289L0.5 6.85717C0.5 3.3462 3.34619 0.5 6.85714 0.5L9.14286 0.5C12.6538 0.5 15.5 3.3462 15.5 6.85717L15.5 9.14289C15.5 12.6539 12.6538 15.5001 9.14286 15.5001L6.85714 15.5001C3.34619 15.5001 0.5 12.6539 0.5 9.14289Z",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 7.42859L7.99996 12",
    stroke: "#C4C4C4",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99985 4.40001C7.77929 4.40001 7.59985 4.22057 7.59985 4.00001C7.59985 3.77945 7.77929 3.60001 7.99985 3.60001C8.22041 3.60001 8.39985 3.77945 8.39985 4.00001C8.39985 4.22057 8.22041 4.40001 7.99985 4.40001Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99983 3.20001C8.44165 3.20001 8.79983 3.55819 8.79983 4.00002C8.79983 4.44184 8.44165 4.80002 7.99983 4.80002C7.55801 4.80002 7.19983 4.44184 7.19983 4.00002C7.19983 3.55819 7.55801 3.20001 7.99983 3.20001Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.e85e7f7c436b2f0676236ccb9f183e6d.svg";
export { ForwardRef as ReactComponent };